<template>
  <div class="onboarding-finish">
    <div class="onboarding-finish-figure" :class="{unlocked:unlocked}">
      <transition name="slide-up-md" mode="out-in" appear >
        <svg v-show="unlocked" width="164" height="165" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M74.3333 108.833L112.667 59" stroke="currentColor" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M51.3333 82L74.3333 108.833" stroke="currentColor" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </transition>
    </div>
    <transition name="fade" mode="out-in" appear>
      <h2 class="txt-heading-small mb-0 mt-4" >
        Your first hub is created!
      </h2>
    </transition>
  </div>
</template>

<script>

  export default {
    name: 'Finish',
    data() {
      return {
        unlocked: false,
      }
    },
    mounted() {
      setTimeout(()=>{
         this.unlocked = true;
      },800);
    }
  };
</script>
